<template>
  <div class="row">
    <div class="col s12 m8 l4 offset-m2 offset-l4">
      <div class="card">
        <div class="card-action white">
          <h5>Sign up to join over 10,000 active merchants!</h5>
        </div>
        <div class="card-content">
          <!-- <img src="ui/img/logo.png" class="responsive-img" alt /> -->
          <form id="formRegister" @submit.prevent="register">
            <div class="row">
              <div class="input-field col s6 m6">
                <input type="text" v-model="fields.firstname" id="firstname" />
                <label for="firstname">First Name</label>
              </div>
              <div class="input-field col s6 m6">
                <input type="text" v-model="fields.lastname" id="lastname" />
                <label for="lastname">Last Name</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12">
                <input type="email" v-model="fields.email" />
                <label for="email">Email Address</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12">
                <input type="text" v-model="fields.phone" />
                <label for="phone">Phone number</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6">
                <input type="password" v-model="fields.password" />
                <label for="password">Password</label>
              </div>
              <div class="input-field col s12 m6">
                <input type="password" v-model="fields.repeat_password" />
                <label for="cpassword">Confirm Password</label>
              </div>
            </div>
            <div class="form-field">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div v-else>
                <button
                  id="registerBtn"
                  class="btn-large waves-effect green darken-2 waves-dark"
                  type="submit"
                  style="width:100%;"
                >
                  Sign Up
                </button>
              </div>
            </div>
          </form>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    $('select').formSelect()
  },
  data() {
    return {
      loading: false,
      fields: {
        relocate: 'register',
        action: 'register',
        signopt: 'vendor'
      }
    }
  },
  methods: {
    register() {
      if (this.ValidateData()) {
        this.loading = true
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', this.fields.relocate)
        bodyFormData.set('action', this.fields.action)
        bodyFormData.set('phone', this.fields.phone)
        bodyFormData.set('password', this.fields.password)
        bodyFormData.set('repeat_password', this.fields.repeat_password)
        bodyFormData.set('email', this.fields.email)
        bodyFormData.set('firstname', this.fields.firstname)
        bodyFormData.set('lastname', this.fields.lastname)
        bodyFormData.set('signopt', this.fields.signopt)
        this.axios
          .post('control1.php', bodyFormData)
          .then(response => {
            if (response.data.status == 1) {
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'success' })
              // $('#registerBtn').disabled = true
              window.location.assign('profile.php')
            } else {
              this.loading = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.loading = false
          })
      }
    },
    ValidateData() {
      if (this.fields.email) {
        if (this.fields.phone) {
          if (this.fields.phone.toString().length === 11) {
            if (this.fields.password) {
              if (this.fields.repeat_password) {
                if (this.fields.repeat_password == this.fields.password) {
                  if (this.fields.signopt) {
                    return true
                  } else {
                    $('.toast').hide()
                    M.toast({
                      html: 'Please select a category',
                      classes: 'info'
                    })
                  }
                } else {
                  $('.toast').hide()
                  M.toast({
                    html: 'Confirm password must match',
                    classes: 'info'
                  })
                }
              } else {
                $('.toast').hide()
                M.toast({
                  html: 'Repeat password is required!',
                  classes: 'info'
                })
              }
            } else {
              $('.toast').hide()
              M.toast({ html: 'Password field is required!', classes: 'info' })
            }
          } else {
            $('.toast').hide()
            M.toast({
              html: 'Phone number must be 11 characters',
              classes: 'info'
            })
          }
        } else {
          $('.toast').hide()
          M.toast({ html: 'Phone number is required!', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'E-mail field is required!', classes: 'info' })
      }
    }
  }
}
</script>
<style scoped>
label {
  font-size: 1rem;
  color: #9e9e9e;
  font-weight: bold;
}
.card-content {
  padding: 0px 24px 24px;
}
.card .card-action {
  padding: 6px 24px;
}
.row {
  margin-bottom: 0px;
}
</style>
